import React, { createContext, useContext, useEffect, useState, useMemo, useCallback } from "react";
import { translations } from "@/i18n/translations";

const LanguageContext = createContext(null);

export const LanguageProvider = ({ children }) => {
  const [lang, setLang] = useState(() => localStorage.getItem("isaloon_lang") || "ar");

  useEffect(() => {
    document.documentElement.lang = lang;
    document.documentElement.dir = lang === "ar" ? "rtl" : "ltr";
    localStorage.setItem("isaloon_lang", lang);
  }, [lang]);

  const t = useCallback((key) => translations[lang]?.[key] ?? key, [lang]);
  const toggleLang = useCallback(() => setLang((l) => (l === "ar" ? "en" : "ar")), []);

  const value = useMemo(() => ({ lang, setLang, t, toggleLang, isRTL: lang === "ar" }), [lang, t, toggleLang]);
  return <LanguageContext.Provider value={value}>{children}</LanguageContext.Provider>;
};

export const useLanguage = () => {
  const ctx = useContext(LanguageContext);
  if (!ctx) throw new Error("useLanguage outside provider");
  return ctx;
};
